import request from './common/request'
import qs from 'qs'
import { exportExcelByGet } from './common/exportExcel'

import { MERCHANT_EVALUATION_PROJECT_URI } from './urls'

// 列表
async function list(params) {
  return request({
    url: MERCHANT_EVALUATION_PROJECT_URI,
    method: 'GET',
    params
  })
}

// 汇总
async function summary(params) {
  return request({
    url: `${MERCHANT_EVALUATION_PROJECT_URI}/summary`,
    method: 'GET',
    params
  })
}

// 详情
async function getById(id) {
  return request({
    url: `${MERCHANT_EVALUATION_PROJECT_URI}/${id}`,
    method: 'GET'
  })
}

// 插入
async function insert(data) {
  return request({
    url: MERCHANT_EVALUATION_PROJECT_URI,
    method: 'POST',
    data
  })
}

async function batchInsert(data) {
  return request({
    url: `${MERCHANT_EVALUATION_PROJECT_URI}/batchAdd`,
    method: 'POST',
    data
  })
}

// 更新
// async function update (data) {
//   return request(
//     {
//       url: `${MERCHANT_EVALUATION_PROJECT_URI}/${data.id}`,
//       method: 'PUT',
//       data: qs.stringify(data)
//     }
//   )
// }

// 删除
async function remove(id) {
  return request({
    url: `${MERCHANT_EVALUATION_PROJECT_URI}/${id}`,
    method: 'DELETE'
  })
}

async function updateFinishStatus(data) {
  return request({
    url: `${MERCHANT_EVALUATION_PROJECT_URI}/${data.id}/changeFinishStatus/${data.finishStatus}`,
    method: 'PUT',
    data
  })
}

async function getSchemeConfigs() {
  return request({
    url: `${MERCHANT_EVALUATION_PROJECT_URI}/schemeConfigs`,
    method: 'GET'
  })
}

async function getSchemeItemConfigs(params) {
  return request({
    url: `${MERCHANT_EVALUATION_PROJECT_URI}/schemeConfigs/${params.schemeCfgId}/items`,
    method: 'GET',
    params
  })
}

async function getJudges() {
  return request({
    url: `${MERCHANT_EVALUATION_PROJECT_URI}/judges`,
    method: 'GET'
  })
}

async function getProjectJudges(id) {
  return request({
    url: `${MERCHANT_EVALUATION_PROJECT_URI}/${id}/judges`,
    method: 'GET'
  })
}

async function batchSaveProjectJudges(data) {
  return request({
    url: `${MERCHANT_EVALUATION_PROJECT_URI}/${data.id}/judges/batchSave`,
    method: 'PUT',
    data: data.projectJudges
  })
}

/**
 * 自动编号
 * @param {unknown} projectId
 * @param {number} start 送入起始编号
 * @returns
 */
async function batchAutoTagNum(projectId, start = 1) {
  return request({
    url: `${MERCHANT_EVALUATION_PROJECT_URI}/${projectId}/autoOptTagNum`,
    method: 'PUT',
    // data: { start }
    data: qs.stringify({ start })
  })
}

async function getEntryValueEvals(params) {
  return request({
    url: `${MERCHANT_EVALUATION_PROJECT_URI}/${params.id}/entryValueEvals`,
    method: 'GET',
    params
  })
}

// 评分管理 - 获取所有评分列表
async function getEntryValueEvalsAll(params) {
  return request({
    url: `${MERCHANT_EVALUATION_PROJECT_URI}/${params.id}/entryValueEvals/all`,
    method: 'GET',
    params
  })
}

/**
 * 更新标签名称
 * @param {*} params
 * @returns
 */
async function updateNoTag(params) {
  return request({
    url: `${MERCHANT_EVALUATION_PROJECT_URI}/${params.projectId}/entryValueEvals/${params.entryValueId}/updateNoTag`,
    method: 'PUT',
    data: qs.stringify(params)
  })
}

async function getEntryValueRanks(params) {
  return request({
    url: `${MERCHANT_EVALUATION_PROJECT_URI}/${params.id}/entryValueRanks`,
    method: 'GET',
    params
  })
}

async function getEntryValueDetail(params) {
  return request({
    url: `${MERCHANT_EVALUATION_PROJECT_URI}/${params.id}/entryValues/${params.entryValueId}`,
    method: 'GET',
    params
  })
}

async function getEntryValueRankIds(params) {
  return request({
    url: `${MERCHANT_EVALUATION_PROJECT_URI}/${params.id}/entryValues/${params.entryValueId}/rankIds`,
    method: 'GET',
    params
  })
}

async function releaseRank(params) {
  return request({
    url: `${MERCHANT_EVALUATION_PROJECT_URI}/${params.id}/entryValues/${params.entryValueId}/releaseRank/${params.rankId}`,
    method: 'PUT'
  })
}

async function cancelRank(params) {
  return request({
    url: `${MERCHANT_EVALUATION_PROJECT_URI}/${params.id}/entryValues/${params.entryValueId}/cancelRank/${params.rankId}`,
    method: 'PUT'
  })
}

async function submitEvals(data) {
  return request({
    url: `${MERCHANT_EVALUATION_PROJECT_URI}/${data.id}/entryValues/${data.entryValueId}/judges/${data.judgeId}/eval`,
    method: 'POST',
    data
  })
}

async function finishEntryValueEval(data) {
  return request({
    url: `${MERCHANT_EVALUATION_PROJECT_URI}/${data.id}/entryValues/${data.entryValueId}/finishEval`,
    method: 'POST'
  })
}

async function promoteEntryValue(data) {
  return request({
    url: `${MERCHANT_EVALUATION_PROJECT_URI}/${data.id}/entryValues/${data.entryValueId}/promote`,
    method: 'POST',
    data: qs.stringify({
      nextCompetitionId: data.nextCompetitionId,
      nextMatchId: data.nextMatchId,
      nextSessionId: data.nextSessionId,
      nextStageId: data.nextStageId
    })
  })
}

async function siftedOutEntryValue(data) {
  return request({
    url: `${MERCHANT_EVALUATION_PROJECT_URI}/${data.id}/entryValues/${data.entryValueId}/shiftedOut`,
    method: 'POST'
  })
}

async function getEntryValueEvalItemValues(params) {
  return request({
    url: `${MERCHANT_EVALUATION_PROJECT_URI}/${params.id}/entryValues/${params.entryValueId}/itemValues`,
    method: 'GET'
  })
}

async function exportEvalResult(params) {
  // const filename = `${moment().format('YYYY-MM-DD')}-报名表-${params.matchId}.xlsx`
  return exportExcelByGet(params, `${MERCHANT_EVALUATION_PROJECT_URI}/${params.id}/entryValueEvals/export`, params.filename)
}

async function exportEvalResult2(params) {
  return exportExcelByGet(params, `${MERCHANT_EVALUATION_PROJECT_URI}/${params.id}/entryValueEvals/export2`, params.filename)
}

/**
 * 创建参评记录 PDF / 收件单导出任务
 * @param {number|string} projectId 评审项目 ID
 * @param {Object} body { entryValueIds, columnKeys?, sealImageUrl?, sealPayload?, receiptExpireAt? }
 */
async function createExportEntryPdfTask(projectId, body) {
  return request({
    url: `${MERCHANT_EVALUATION_PROJECT_URI}/${projectId}/export-entry-pdf/tasks`,
    method: 'POST',
    data: body
  })
}

/**
 * 获取导出任务 PDF 临时下载地址
 * @param {number|string} projectId 评审项目 ID
 * @param {number|string} taskId 导出任务 ID
 */
async function getExportEntryPdfTaskDownloadUrl(projectId, taskId) {
  return request({
    url: `${MERCHANT_EVALUATION_PROJECT_URI}/${projectId}/export-entry-pdf/tasks/${taskId}/download-url`,
    method: 'GET'
  })
}

/**
 * 取消排队中的导出任务（6.1A 单评审项目路径）
 * POST /merchant/evaluation/project/{id}/export-entry-pdf/tasks/{taskId}/cancel
 * 仅 PENDING 可取消为 CANCELLED；路径 id 须与该任务的 evalProjectId 一致；无 Body。
 */
async function cancelExportEntryPdfTask(projectId, taskId) {
  return request({
    url: `${MERCHANT_EVALUATION_PROJECT_URI}/${projectId}/export-entry-pdf/tasks/${taskId}/cancel`,
    method: 'POST'
  })
}

export default {
  list,
  summary,
  getById,
  insert,
  batchInsert,
  // update,
  remove,
  updateFinishStatus,
  getSchemeConfigs,
  getSchemeItemConfigs,
  getJudges,
  getProjectJudges,
  batchSaveProjectJudges,
  batchAutoTagNum,
  getEntryValueEvals,
  getEntryValueEvalsAll,
  updateNoTag,
  getEntryValueRankIds,
  releaseRank,
  cancelRank,
  getEntryValueRanks,
  getEntryValueDetail,
  submitEvals,
  finishEntryValueEval,
  promoteEntryValue,
  siftedOutEntryValue,
  getEntryValueEvalItemValues,
  exportEvalResult2,
  exportEvalResult,
  createExportEntryPdfTask,
  getExportEntryPdfTaskDownloadUrl,
  cancelExportEntryPdfTask
}



// WEBPACK FOOTER //
// ./src/api/merchant-evaluation-project.js